
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.958","height":"16.033"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.5 .5)","fill":"none","stroke":"#9ea9c8","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"5.106","height":"5.106","rx":"1.867","transform":"rotate(180 5.016 2.553)"}}),_c('line',{attrs:{"y1":"1.486","transform":"translate(7.479 5.135)"}}),_c('rect',{attrs:{"width":"5.106","height":"5.106","rx":"1.867","transform":"rotate(-180 2.553 7.516)"}}),_c('line',{attrs:{"y1":"1.486","transform":"translate(2.553 7.968)"}}),_c('rect',{attrs:{"width":"5.106","height":"5.106","rx":"1.867","transform":"rotate(-180 7.479 7.516)"}}),_c('line',{attrs:{"y1":"1.486","transform":"translate(12.405 7.968)"}}),_c('line',{attrs:{"x1":"9.836","transform":"translate(2.569 7.968)"}})])])
          )
        }
      }
    